import SummaryEmail from './SummaryEmail'

export default SummaryEmail
